import React from "react";
import { useNavigate } from "react-router";

function MyProfile() {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col p-3">
            <div
                onClick={() => {
                    navigate("/");
                }}
                className="flex items-center opacity-60 text-sm transition-all hover:cursor-pointer hover:opacity-100 font-sourcecodepro"
            >
                &larr; back
            </div>
        </div>
    );
}

export default MyProfile;
